import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import {
  getAllBusinesses,
  BusinessOption,
} from '@/application/requests/financial';

export interface BusinessState {
  allBusinessOptions: BusinessOption[];
  allBusinessOptionsLoading: boolean;
  allBusinessOptionsLoaded: boolean;
}

const initialState: BusinessState = {
  allBusinessOptions: [],
  allBusinessOptionsLoading: false,
  allBusinessOptionsLoaded: false,
};

export const fetchAllBusinessesForCombobox = createAsyncThunk(
  'business/fetchAllForCombobox',
  async (_, { rejectWithValue }) => {
    const response = await getAllBusinesses();

    if (!response.success || !response.data) {
      return rejectWithValue(response.message || 'Failed to fetch businesses');
    }

    return response.data;
  }
);

const businessSlice = createSlice({
  name: 'business',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchAllBusinessesForCombobox.pending, (state) => {
        state.allBusinessOptionsLoading = true;
      })
      .addCase(fetchAllBusinessesForCombobox.fulfilled, (state, action) => {
        state.allBusinessOptions = action.payload;
        state.allBusinessOptionsLoading = false;
        state.allBusinessOptionsLoaded = true;
      })
      .addCase(fetchAllBusinessesForCombobox.rejected, (state) => {
        state.allBusinessOptionsLoading = false;
        state.allBusinessOptionsLoaded = false;
      });
  },
});

export default businessSlice.reducer;
